import gql from 'graphql-tag';

const PCH_USER = gql`
	query FetchUserInfo($pat: String, $gmt: String) {
		fetchUserInfo(pat: $pat, gmt: $gmt) {
			success
			status
			message
			body {
				EmailAddress
				Title
				FirstName
				LastName
				Address1
				City
				State
				ZipCode
			}
		}
	}
`;

export default PCH_USER;